import LayoutIndex from 'layouts/index'
import LayoutCredenciada from 'layouts/credenciada'

//LOGIN
import Login from 'appsCredenciada/login/index'
import Logout from 'common/logout'

//MEU CADASTRO
import Cadastro from 'appsCredenciada/meu-cadastro/index'

//CONSULTA
import Consulta from 'appsCredenciada/consulta/index'
import ConsultaEditar from 'appsCredenciada/consulta/editar'


//TEMPLATE
import _404 from 'apps/template/404'
import _511 from 'apps/template/511'
import _200 from 'apps/template/200'
import _500 from 'apps/template/500'

const routes = [
  {
    name: '404',
    path: '*',
    meta: { requiresAuth: false },
    component: _404,
  },
  {
    path: '/',
    meta: { requiresAuth: false },
    component: LayoutIndex,
    children: [
      {
        path: '',
        component: _511,
        meta: {
          requiresAuth: false,
          disablePageHeader: true,
          title: 'Cliente não Encontardo',
          navigation: [
            { text: 'Cliente não Encontardo', active: true }
          ]
        },
      },
      {
        path: '/:tenant',
        meta: { requiresAuth: false },
        component: LayoutCredenciada,
        children: [
          //LOGIN
          {
            path: '',
            component: Login,
            meta: {
              requiresAuth: false,
              disablePageHeader: true,
              title: 'Login',
              navigation: [
                { text: 'Login', active: true }
              ]
            },
          },
          {
            path: 'login',
            name: 'parceiro.login',
            component: Login,
            meta: {
              requiresAuth: false,
              disablePageHeader: true,
              title: 'Login',
              navigation: [
                { text: 'Login', active: true }
              ]
            },
          },
          {
            path: 'logout',
            name: 'logout',
            component: Logout,
            meta: {
              requiresAuth: false,
              disablePageHeader: true,
              title: 'Sair do Sistema',
              navigation: [
                { text: 'Sair do Sistema', active: true }
              ]
            },
          },
          //HOME
          {
            path: 'consultas',
            name: 'parceiro.home',
            component: Consulta,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Consultas',
              navigation: [
                { text: 'Consultas', to: { name: 'parceiro.consulta' }, icon: 'fa fa-address-card', active: true }

              ]
            },
          },
          //MEU CADASTRO
          {
            path: 'meu-cadastro',
            name: 'parceiro.cadastro',
            component: Cadastro,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Meu Cadastro',
              navigation: [
                { text: 'Meu Cadastro', to: { name: 'parceiro.cadastro' }, icon: 'fa fa-address-card', active: true }

              ]
            },
          },
          //CONSULTAS
          {
            path: 'consultas',
            name: 'parceiro.consulta',
            component: Consulta,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Consultas',
              navigation: [
                { text: 'Consultas', to: { name: 'parceiro.consulta' }, icon: 'fa fa-address-card', active: true }

              ]
            },
          },
          {
            path: 'consultas/editar/:consulta',
            name: 'parceiro.consulta.edt',
            component: ConsultaEditar,
            meta: {
              requiresAuth: true,
              disablePageHeader: false,
              title: 'Editar Consulta',
              navigation: [
                { text: 'Consultas', to: { name: 'parceiro.consulta' }, icon: 'fa fa-address-card', active: false },
                { text: 'Editar', to: { name: 'parceiro.consulta.edt' }, icon: 'fa fa-pencil-square-o', active: true }
              ]
            },
          },
        ]
      },
    ]
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/parceiro.js